import Model from "@/lib/model/model";

export class Checkpoint extends Model {
  checkpointName = ""; // 得分点名
  keyWordList: string[] = [""]; // 关键词列表
  scorePercent = 0; // 得分百分比

  // 不需要提交
  expand = false;
  allKeyWords = "";
  showErr = false;
}

export class ScoreRole extends Model {
  checkpointList: Checkpoint[] = [new Checkpoint()]; // 得分点列表
  aiType = 0; // 0 = 关键词 2 = AI判断得分点
}

export class ScoreRoleMap extends Model {
  scoreRule: ScoreRole = new ScoreRole(); // 得分点列表
  dimensionKey = "";

  //不需要提交
  dimensionName = "";
}
